import CardPlayer from "../../components/CardPlayer";

import {
  CarouselGroup1,
  CarouselGroup2,
  CarouselBar1,
  Container,
  FirstTitle,
  InstitutoLogo,
  IntroductionDetails,
  Logos,
  MainDetailsSection,
  MainDetailsText,
  MainDetailsTitle,
  MainImage, MainTitle,
  SecondTitle,
  ThirdTitle,
  UnifespLogo,
  HeroImgTitlle,
  ContactButton,
  IntroductionArrow,
  SectionOne,
  SectionTwo,
  ContactSection,
  ContactCards,
  ContactLinks,
  ContactLogos,
  ContactTitle
} from "./AboutElements";
import partners from "./partners.json"

export default function About() {

  return (
    <Container>
      <SectionOne>
        <HeroImgTitlle>
          <MainImage></MainImage>
          <IntroductionDetails>
            Projeto desenvolvido para apresentar de maneira mais clara informações sobre a vacinação da população brasileira.
          </IntroductionDetails>
          <ContactButton href="#ContactSection"> Contato </ContactButton>
          <IntroductionArrow href="#SectionTwo"></IntroductionArrow>
        </HeroImgTitlle>
      </SectionOne>

      <SectionTwo id="SectionTwo">
        <MainDetailsSection>
          <MainDetailsTitle>Detalhamento geral do Projeto</MainDetailsTitle>
          <MainDetailsText>O projeto Fluxo de Vacinação foi fundado por alunos do Instituto de Ciência e Tecnologia-UNIFESP (ICT-UNIFESP) em parceria com o Instituto Federal de Aquidauana (IFMS-Aquidauana). Nosso projeto tem como objetivo ressaltar para a sociedade o comportamento dos municípios brasileiros ao longo do período de vacinação contra o vírus da COVID-19. Com esse projeto, esperamos trazer maior transparência e entendimento dos dados divulgados pela mídia e também, pelos governos estaduais, bem como, além disso, indicar alguns caminhos para tomadas de decisão por parte das secretarias de saúde. Importante salientar que os dados utilizados nesse projeto são retirados do site Vacina Já SP, site de divulgação do governo do estado de São Paulo, e qualquer inconsistência nos mesmos se deve a problemas na própria fonte.</MainDetailsText>
        </MainDetailsSection>
        <MainTitle>
          <FirstTitle>Uma parceria entre alunos e professores.</FirstTitle>
          <Logos>
            <UnifespLogo src="./images/UnifespLogo.png" />
            <InstitutoLogo src="./images/IfmsLogo.png" />
          </Logos>
          <SecondTitle>Equipe</SecondTitle>
          <CarouselGroup1>
            <CarouselBar1>
              {partners.team.map((partner) => (<CardPlayer
                name={partner.name}
                img={partner.img}
                cvLink={partner.cvLink}
                linkedinLink={partner.linkedinLink}
                githubLink={partner.githubLink}
                formation={partner.formation}
              />))}
            </CarouselBar1>
          </CarouselGroup1>
          <ThirdTitle>Colaboradores</ThirdTitle>
          <CarouselGroup2>
            <CarouselBar1>
              {partners.colaborators.map((partner) => (<CardPlayer
                name={partner.name}
                img={partner.img}
                cvLink={partner.cvLink}
                linkedinLink={partner.linkedinLink}
                githubLink={partner.githubLink}
                formation={partner.formation}
              />))}
            </CarouselBar1>
          </CarouselGroup2>

        </MainTitle>
      </SectionTwo>
      <ContactSection id="ContactSection">
        <ContactTitle>Possui alguma sugestão ou gostaria de entrar em contato conosco?</ContactTitle>
        <ContactTitle>Entre em contato via:</ContactTitle>
        <ContactCards>
          <ContactLinks href="https://www.instagram.com/fluxovacinacao/" target="_blank"> <ContactLogos src="./images/instagram.png" /> Instagram </ContactLinks>
        </ContactCards>
        <ContactCards>
          <ContactLinks href="mailto:projetofluxovacinacao@gmail.com" target="_blank"> <ContactLogos src="./images/email.png" /> Email </ContactLinks>
        </ContactCards>
      </ContactSection>
    </Container>
  )
}